import { _ as _slicedToArray, a as _toConsumableArray } from './_rollupPluginBabelHelpers-84d4d8f6.js';
import React, { useState, useEffect } from 'react';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import Loadable from 'react-loadable';
var FullCalendarComp = Loadable({
  loader: function loader() {
    return import('./fullCalendar.js');
  },
  loading: function loading() {
    return /*#__PURE__*/React.createElement("div", null, "Loading...");
  }
});

require("es6-promise").polyfill();

var WeducCalendar = function WeducCalendar(props) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      newsFeedData = _useState4[0],
      setNewsFeedData = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      modalOpen = _useState6[0],
      setModalOpen = _useState6[1];

  var _useState7 = useState({}),
      _useState8 = _slicedToArray(_useState7, 2),
      modalData = _useState8[0],
      setModalData = _useState8[1];

  var handleDateClick = function handleDateClick(args) {
    var data = {
      title: args.event.title,
      description: args.event._def.extendedProps.description
    };
    setModalData(data);
    setModalOpen(true);
  };

  useEffect(function () {
    var weducAPIURL = props.weducAPIURL ? props.weducAPIURL : "https://weduc.accropress.com/smartfeed/";
    fetch(weducAPIURL + "getcalendardata/" + props.name + "/" + props.container).then(function (response) {
      return response.json();
    }).then(function (jsonList) {
      if (jsonList && jsonList.data && jsonList.data.events && jsonList.data.events.length > 0) {
        jsonList = jsonList.data.events.sort(function (one, two) {
          var date1 = one.start_date;
          var date2 = two.start_date;

          if (date1 < date2) {
            return -1;
          } else if (date1 > date2) {
            return 1;
          }

          return 0;
        });

        if (props.limit && jsonList) {
          var temp = [newsFeedData];
          jsonList = jsonList.splice(0, props.limit);
          jsonList && jsonList.map(function (news, i) {
            temp.push({
              title: news.title,
              date: news.start_date,
              description: news.description
            });
          });
          setNewsFeedData(temp);
          setLoading(false);
        } else {
          var _temp = [newsFeedData];
          jsonList && jsonList.map(function (news, i) {
            _temp.push({
              title: news.title,
              date: news.start_date,
              description: news.description
            });
          });
          setNewsFeedData(_temp);
          setLoading(false);
        }

        props.loadedEvent(true);

        if (props.state && props.setState) {
          var _temp2 = _toConsumableArray(props.state);

          jsonList && jsonList.map(function (news, i) {
            _temp2.push({
              title: news.title,
              date: news.start_date,
              description: news.description
            });
          });
          props.setState(_temp2);
        }
      }

      setLoading(false);
    });
  }, []);
  var Html = props.html || null;

  if (props.state && props.setState && Html) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, newsFeedData ? newsFeedData.map(function (news, i) {
      return /*#__PURE__*/React.createElement(Html, {
        key: i,
        data: news,
        route: props.route,
        state: props.state,
        setState: props.setState
      });
    }) : loading ? /*#__PURE__*/React.createElement("div", {
      className: "components-loading-wrap"
    }, /*#__PURE__*/React.createElement("div", {
      "class": "components-loading-spinner"
    }, /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null), /*#__PURE__*/React.createElement("div", null)), /*#__PURE__*/React.createElement("span", null, "Loading calendar events")) : /*#__PURE__*/React.createElement("div", {
      className: "no-results"
    }, "There are no upcoming dates to display."));
  } else {
    return /*#__PURE__*/React.createElement("div", {
      className: "cal-placeholder"
    }, /*#__PURE__*/React.createElement(FullCalendarComp, {
      weducAPIURL: props.weducAPIURL,
      handleDateClick: handleDateClick,
      calendarData: newsFeedData
    }), /*#__PURE__*/React.createElement(Modal, {
      classNames: {
        modal: "AccroModal"
      },
      open: modalOpen,
      onClose: function onClose() {
        return setModalOpen(false);
      },
      center: true
    }, /*#__PURE__*/React.createElement("div", {
      dangerouslySetInnerHTML: {
        __html: modalData.description
      }
    }), modalData.attachment && modalData.attachment.length > 0 && /*#__PURE__*/React.createElement("ul", {
      className: "AccroModal_Attachments"
    }, modalData.attachment.map(function (attachment) {
      return /*#__PURE__*/React.createElement("li", {
        className: "AccroModal_Attachments_Attachement"
      }, /*#__PURE__*/React.createElement("a", {
        href: attachment.external_url,
        title: attachment.title,
        target: "_blank",
        rel: "noopener noreferer"
      }, attachment.title));
    }))));
  }
};

export default WeducCalendar;